// extracted by mini-css-extract-plugin
module.exports = {"companyCreateBox":"styles_companyCreateBox__20ktd","footerButtonContainer":"styles_footerButtonContainer__2EM0V"};